module.exports = __webpack_public_path__ + "img/6_en.203487ef.png";